import React from 'react'
import Navbar from './Navbar'
import './header.scss';

const Header = () => {
    return (
        <div className="header-body">
            <Navbar />
        </div>
    )
}

export default Header
